import { ProcessedArtist } from '@app/data/clients/monolithClients/explore/types';
import {
  Box,
  Carousel,
  constants,
  Slide,
  Text,
} from '@redbubble/design-system';
import { useViewportWidth } from '@redbubble/next/hooks';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { AppProps, DeviceType } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import { ArtistCard } from './ArtistCard';

const message = defineMessages({
  featuredArtist: { defaultMessage: 'Featured artists' },
});

export interface ArtistFeedProps {
  artists: [ProcessedArtist, ...ProcessedArtist[]];
}

export const ArtistFeed: React.FC<ArtistFeedProps> = ({ artists }) => {
  const intl = useIntl();
  const { deviceType } = usePageProps<AppProps>();
  const { isOrAbove } = useViewportWidth(deviceType);
  const isDesktop = isOrAbove(DeviceType.Desktop);

  return (
    <>
      <Box paddingBottom={1}>
        <Text block element="h2" type="display2">
          {intl.formatMessage(message.featuredArtist)}
        </Text>
      </Box>
      <Carousel
        profile={isDesktop ? constants.DESKTOP : constants.MOBILE}
        slidesPerView="auto"
        marginTop={1}
      >
        {artists.map(({ artist, cover }) => {
          return (
            <Slide key={cover} data-testid="artist-feed">
              <ArtistCard artist={artist} coverImage={cover} />
            </Slide>
          );
        })}
      </Carousel>
    </>
  );
};
